import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type CountriesAreaProps = {
  countriesInformation: {
    name: string
  }[]
}

const getCountriesList = (countries: string[]) => {
  const newCountriesVariable = [...countries]

  if (newCountriesVariable.length === 1) return newCountriesVariable[0]

  const lastCountry = newCountriesVariable.pop()
  const restOfCountries = newCountriesVariable.join(', ')

  return `${restOfCountries} and ${lastCountry}.`
}

const CountriesArea = ({ countriesInformation }: CountriesAreaProps) => {
  const countriesNameList = countriesInformation.map((country) => country.name)
  const parsedCountriesList = getCountriesList(countriesNameList)

  return (
    <Box alignItems="flexStart" justifyContent="flexStart">
      <Box paddingBottom="s8">
        <Text size="400" weight="medium" color="grey1000">
          {i18n.t('marketplace.countries_area.title')}
        </Text>
      </Box>

      <Text size="300" color="grey800" overflowWrap>
        {parsedCountriesList}
      </Text>
    </Box>
  )
}

export default CountriesArea
